
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/pass/couponEnter",
      function () {
        return require("private-next-pages/m/pass/couponEnter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/pass/couponEnter"])
      });
    }
  